{
    "actions": {
        "row": {
            "send_by_mail": "Send by mail",
            "refresh_transaction": "Refresh"
        }
    },
    "count": {
        "transaction": "{{transactionsCount}} transaction",
        "transactions": "{{transactionsCount}} transactions"
    },
    "keys": {
        "reconciliation_number": "Reconciliation #",
        "remittance_number": "File #",
        "transaction_date": "Transaction date",
        "reconciliation_code": "Status",
        "total_amount": "Amount",
        "legal_name": "Legal name",
        "transaction_count": "Transactions",
        "total_revenue": "Total amount: {{amount}}"
    },
    "filter": {
        "placeholder": {
            "reconciliation_number": "Filter by reconciliation number",
            "remittance_number": "Filter by file number",
            "total_amount": "Filter by amount",
            "legal_name": "Filter by legal name",
            "transaction_count": "Filter by transactions"
        }
    },
    "modal": {
        "send_by_mail": {
            "success": "Your request has been taken into account, the sending of the mails will be done in a few minutes",
            "UNKNOWN_ERROR": "An error occurred while sending the mails",
            "title": {
                "remote_collection": "Send remote collection by mail",
                "transaction": "Send holder ticket by mail"
            },
            "message": {
                "remote_collection": "Contract $t(contract:application.{{application}}) #{{contract}} on {{localTransactionDate}} at {{localTransactionTime}}",
                "transaction": "Contract $t(contract:application.{{application}}) #{{contract}}, remittance #{{reconciliationNumber}} on {{localTransactionDate}} at {{localTransactionTime}}"
            },
            "confirm": {
                "single": "The mail will be sent to the following recipient:",
                "multiple": "The mail will be sent to the following recipients:"
            }
        }
    },
    "status": {
        "RECONCILED_TOTALS_CORRECT": "Correct amounts",
        "RECONCILED_TOTALS_INCORRECT": "Incorrect amounts",
        "EMPTY": "Empty",
        "NOT_COMPLETED": "Unsuccessful",
        "NOT_EMPTY": "Not empty",
        "TOTALS_INVALID": "Invalid totals",
        "INTERRUPTED": "Interrupted"
    },
    "toast": {
        "refresh": {
            "loading": "Refreshing...",
            "success": "Refreshing completed successfully",
            "error": "Error while refreshing the remittance"
        }
    }
}